import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {Router} from '@angular/router';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate() {
    if (sessionStorage.getItem('yaghootToken')) {
      this.router.navigate(['/cards']);
      return true;
    }
    if (localStorage.getItem('mobileUserToken')) {
      return true;
    }
    this.router.navigate(['/register']);
    return false;
  }
}
